/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import { Box } from '@mui/material';
import { Grid } from '@mui/system';
import { SectionShimmer, CardShimmer, BaseShimmer } from '../index';
import '../shimmer.scss';

function AboutShimmer() {
  return (
    <Box className="about-shimmer-wrap">
      {/* Hero Section Shimmer */}
      <Box sx={{ padding: '60px 100px', textAlign: 'center' }}>
        <BaseShimmer height="48px" width="60%" style={{ margin: '0 auto 20px' }} />
        <BaseShimmer height="18px" width="80%" style={{ margin: '0 auto 40px' }} />
      </Box>

      {/* Scrolling Image */}
      <Box sx={{ padding: '0 100px 60px' }}>
        <BaseShimmer height="300px" borderRadius="12px" />
      </Box>

      {/* Aim Section Shimmer */}
      <Box sx={{ padding: '60px 100px' }}>
        <SectionShimmer
          title
          subtitle
          cards={3}
          gridColumns={3}
          showCardImages
          showCardButtons={false}
        />
      </Box>

      {/* Service Section Shimmer */}
      <Box sx={{ padding: '60px 100px', backgroundColor: '#f8f9fa' }}>
        <SectionShimmer
          title
          subtitle
          cards={4}
          gridColumns={2}
          showCardImages
          showCardButtons
        />
      </Box>

      {/* Video Section Shimmer */}
      <Box sx={{ padding: '60px 100px' }}>
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="36px" width="80%" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="90%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="85%" style={{ marginBottom: '30px' }} />
            <BaseShimmer height="42px" width="140px" borderRadius="6px" />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="300px" borderRadius="12px" />
          </Grid>
        </Grid>
      </Box>

      {/* Schedule Section Shimmer */}
      <Box sx={{ padding: '60px 100px', backgroundColor: '#f8f9fa' }}>
        <Box sx={{ textAlign: 'center' }}>
          <BaseShimmer height="36px" width="50%" style={{ margin: '0 auto 20px' }} />
          <BaseShimmer height="18px" width="70%" style={{ margin: '0 auto 30px' }} />
          <BaseShimmer height="42px" width="160px" borderRadius="6px" style={{ margin: '0 auto' }} />
        </Box>
      </Box>

      {/* Partner Section Shimmer */}
      <Box sx={{ padding: '60px 100px' }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 7 }}>
            <BaseShimmer height="36px" width="80%" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="42px" width="140px" borderRadius="6px" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="95%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="80%" />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <BaseShimmer height="300px" borderRadius="12px" />
          </Grid>
        </Grid>
      </Box>

      {/* Benefits Section Shimmer */}
      <Box sx={{ padding: '60px 100px', backgroundColor: '#f8f9fa' }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 7 }}>
            <BaseShimmer height="36px" width="80%" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="42px" width="140px" borderRadius="6px" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="90%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="85%" />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
              {Array.from({ length: 4 }).map((_, index) => (
                <CardShimmer
                  key={index}
                  showImage
                  showButton={false}
                  textLines={2}
                />
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Clinic Section Shimmer */}
      <Box sx={{ padding: '60px 100px' }}>
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 7 }}>
            <BaseShimmer height="36px" width="80%" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="42px" width="140px" borderRadius="6px" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="95%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="80%" />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <BaseShimmer height="400px" borderRadius="12px" />
          </Grid>
        </Grid>
      </Box>

      {/* CEO Section Shimmer */}
      <Box sx={{ padding: '60px 100px', backgroundColor: '#f8f9fa' }}>
        <BaseShimmer height="36px" width="40%" style={{ margin: '0 auto 40px' }} />

        <Grid container spacing={3}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ textAlign: 'center' }}>
                <BaseShimmer
                  height="200px"
                  width="200px"
                  variant="circular"
                  style={{ margin: '0 auto 20px' }}
                />
                <BaseShimmer height="24px" width="80%" style={{ margin: '0 auto 12px' }} />
                <BaseShimmer height="16px" width="100%" style={{ margin: '0 auto 6px' }} />
                <BaseShimmer height="16px" width="90%" style={{ margin: '0 auto 6px' }} />
                <BaseShimmer height="16px" width="70%" style={{ margin: '0 auto' }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Location Section Shimmer */}
      <Box sx={{ padding: '60px 100px' }}>
        <BaseShimmer height="36px" width="40%" style={{ margin: '0 auto 40px' }} />

        <Grid container spacing={3}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
              <CardShimmer
                showImage
                showButton={false}
                textLines={2}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default AboutShimmer;
